import React from "react";
import { Formik, Form } from "formik";
import { Stack } from "office-ui-fabric-react";
import { useDriverForm } from "../hooks/useDriverForm";
import { validationSchemaDrivers } from "../actions/validationSchemas";
import NewFormField from "../../common/layout/form/NewFormField";
import NewFormBtns from "../../common/layout/form/NewFormBtns";
import ActivityIndicator from "../../common/layout/ActivityIndicator";
import MessageContainer from "../../auth/components/register/forms/MessageContainer";

const DriverForm: React.FC = () => {
  const {
    handleSubmit,
    initValues,
    cancelForm,
    selectedDrivers,
    loading
  } = useDriverForm();

  return (
    <Formik
      initialValues={initValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchemaDrivers}
    >
      {({ handleSubmit }) => (
        <Form translate="yes" onSubmit={handleSubmit}>
          <Stack>
            <NewFormField name="lastName" label="Nazwisko" />
            <NewFormField name="firstName" label="Imię" />
            <NewFormField name="phone" label="Telefon" />
            <NewFormField name="email" label="Email" />
            <NewFormBtns
              cancelForm={cancelForm}
              submitBtnText={selectedDrivers[0] ? "Zapisz" : "Dodaj"}
              disabled={loading}
              positionAbsolute={true}
            />
          </Stack>
          {loading ? <ActivityIndicator /> : <MessageContainer />}
        </Form>
      )}
    </Formik>
  );
};

export default DriverForm;